import { throttle } from "throttle-debounce";

const INTERSECTION_OPTS = {
	rootMargin: "-50% 0% -50% 0%",
	threshold: [0.0],
};

/**
 * abstract class to hold listeners for element visibility
 * implements IntersectionObserver API when available
 * falls back to scroll, resize, and orientationChange listeners if not
 */
export default class IntersectionObserved {
	constructor(el) {
		this.el = el;
		this.imageObserver = null;
		this.hasBecomeVisible = false;
	}

	/**
	 * Add event handlers to determine element visibility
	 * use either IntersectionObserver API if available
	 * fallback to use scroll, resize, and orientationChange
	 */
	initVisibilityCheck(opts) {
		const intops = Object.assign(INTERSECTION_OPTS, opts);
		// console.log("intops", intops);
		if ("IntersectionObserver" in window) {
			this.imageObserver = new IntersectionObserver(this.intersectionCallback.bind(this), intops);
			this.imageObserver.observe(this.el);
		} else {
			this.throttledIntersectionDelegate = throttle(100, this.insersectionFallback.bind(this));
			document.addEventListener("scroll", this.throttledIntersectionDelegate);
			window.addEventListener("resize", this.throttledIntersectionDelegate);
			window.addEventListener("orientationChange", this.throttledIntersectionDelegate);
			this.insersectionFallback();
		}
	}

	/**
	 * IntersectionObserver API intersection handler
	 */
	intersectionCallback(entries) {
		//console.log('intersectionCallback', entries[0]);

		if (entries[0].isIntersecting) {
			this.imageObserver.unobserve(this.el);
			this.onBecomeVisible();
			return;
		}
	}

	/**
	 * Fallback visibility events handler
	 */
	insersectionFallback() {
		const scrollTop = window.pageYOffset;
		if (this.el.offsetTop < window.innerHeight + scrollTop) {
			document.removeEventListener("scroll", this.throttledIntersectionDelegate);
			window.removeEventListener("resize", this.throttledIntersectionDelegate);
			window.removeEventListener("orientationChange", this.throttledIntersectionDelegate);
			this.onBecomeVisible();
		}
	}

	/**
	 * Init slideshow and non slideshow before after event handlers, timeout, video
	 */
	onBecomeVisible() {
		this.hasBecomeVisible = true;
	}
}
